import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import { classNames } from "../../utils/helpers";
import { focusableSelector } from "../../utils/_private/a11y";
import { NotificationContainer } from './NotificationContainer';
import { NotificationContext } from './Notification.context';
import s from './Notification.module.css';
export const NotificationRegion = (props) => {
    const { position } = props;
    const { queues, options } = React.useContext(NotificationContext);
    const [inspecting, setInspecting] = React.useState(false);
    const ignoreHoverRef = React.useRef(false);
    const rootRef = React.useRef(null);
    const queue = queues[position];
    const { expanded = true, zIndex } = (options === null || options === void 0 ? void 0 : options[position]) || {};
    const regionClassNames = classNames(s.region, s[`--position-${position}`]);
    const filteredLength = queue.filter(item => item.status === 'entered').length;
    let hiddenCount = 0;
    // If touch event was triggered – ignore hover events
    const handleTouchStart = () => {
        ignoreHoverRef.current = true;
    };
    const handleClick = (e) => {
        let currentEl = e.target;
        let isFocusable = false;
        while (currentEl && currentEl !== rootRef.current && !isFocusable) {
            isFocusable = currentEl.matches(focusableSelector);
            currentEl = currentEl.parentElement;
        }
        // Change inspecting mode when clicking on static content
        if (!isFocusable) {
            setInspecting(prevInspecting => !prevInspecting);
        }
        // Click is called last so we reset our hover events ignore
        ignoreHoverRef.current = false;
    };
    const handleMouseEnter = () => {
        if (ignoreHoverRef.current)
            return;
        setInspecting(true);
    };
    const handleMouseLeave = () => {
        if (ignoreHoverRef.current)
            return;
        setInspecting(false);
    };
    React.useEffect(() => {
        if (queue.length === 0)
            setInspecting(false);
    }, [queue.length]);
    if (!queue.length)
        return null;
    return (
    // We only use onClick for touch devices since touchend is not supported
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    _jsx("ul", { role: "region", "aria-live": "polite", className: regionClassNames, ref: rootRef, style: { zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : options === null || options === void 0 ? void 0 : options.zIndex }, onTouchStart: handleTouchStart, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: queue.map((data, index) => {
            const visibleIndex = filteredLength - index + hiddenCount - 1;
            if (data.status !== 'entered')
                hiddenCount += 1;
            return (_jsx(NotificationContainer, Object.assign({}, data, { index: visibleIndex, inspected: inspecting || !!expanded }), data.id));
        }) }));
};
